(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Accessories"]) return;
  try {
    





Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Brand"]) return;
  try {
    

$(document).ready(function(){
var url=window.location.href;
$('.saucepan-col').click(function(){
 
 $('.saucepan-col').removeClass('active');
  $(this).addClass('active');
   var fil =  $('.saucepan-col.active .text-area').text();
  var fuldata =  $('.saucepan-col.active .text-details').text();

var img=$('.saucepan-col.active img').attr('data-src')
  Cookies.set('named', fil);
 Cookies.set('img', img);
Cookies.set('fuldata', fuldata);

  var fin = fil.toLowerCase();

  var final = fin.split(" ").join("-");
  var tit = $('.section-header h1').html();
  tit = tit.toLowerCase();
   tit = tit.split(" ").join("-");
  console.log("https://meyerindia.myshopify.com/collections/"+tit+"/"+final);
 window.location.href ="https://meyerindia.myshopify.com/collections/"+tit+"/"+final; 
});

//var pageName = url.split("/")[4];
var pageName1 = url.split("/")[5];
console.log(pageName1);
if(pageName1){
$('.header-hidden h1').addClass('fin');
 
$('.header-hidden h1').html(Cookies.get('named'));
$('.header-hidden .collection-hero__image-wrapper img').attr('src',(Cookies.get('img')));

$('.header-hidden .grid .grid__item .rte').html(Cookies.get('fuldata'));

}
  });


Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accessories-subcollection"]) return;
  try {
    





Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bakeware-subcollection"]) return;
  try {
    





Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bakeware"]) return;
  try {
    

$(document).ready(function(){
var url=window.location.href;
$('.saucepan-col').click(function(){
 
 $('.saucepan-col').removeClass('active');
  $(this).addClass('active');
   var fil =  $('.saucepan-col.active .text-area').text();
  var fuldata =  $('.saucepan-col.active .text-details').text();

var img=$('.saucepan-col.active img').attr('data-src')
  Cookies.set('named', fil);
 Cookies.set('img', img);
Cookies.set('fuldata', fuldata);

  var fin = fil.toLowerCase();

  var final = fin.split(" ").join("-");
  var tit = $('.section-header h1').html();
  tit = tit.toLowerCase();
   tit = tit.split(" ").join("-");
  console.log("https://meyerindia.myshopify.com/collections/"+tit+"/"+final);
 window.location.href ="https://meyerindia.myshopify.com/collections/"+tit+"/"+final; 
});

//var pageName = url.split("/")[4];
var pageName1 = url.split("/")[5];
console.log(pageName1);
if(pageName1){
$('.header-hidden h1').addClass('fin');
 
$('.header-hidden h1').html(Cookies.get('named'));
$('.header-hidden .collection-hero__image-wrapper img').attr('src',(Cookies.get('img')));

$('.header-hidden .grid .grid__item .rte').html(Cookies.get('fuldata'));

}
  });


Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookware-saucepan-brand"]) return;
  try {
    





Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookware-saucepan"]) return;
  try {
    





Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });




  } catch(e) { console.error(e); }
})();
})();
